"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("./config/index");
var CONFIG = {
    version: 6,
    autoRun: true,
    ignoreDefaultSources: true,
    cdnSources: index_1.cdnSources,
    duration: 60000,
};
exports.default = CONFIG;
//# sourceMappingURL=config.js.map